import { GlossaryItemRowSkeleton } from './L10nGlossaryItemRow'

export const L10nGlossaryLocaleSkeleton = ({ count = 10 }: { count?: number }) => {
  const skeletonItems = Array.from({ length: count }, (_, index) => (
    <GlossaryItemRowSkeleton key={`skeleton-item-${index}`} />
  ))

  return (
    <div className="relative">
      <div className="absolute bottom-0 left-0 z-10 size-full bg-gradient-to-b from-transparent to-fg-primary" />
      <ul>{skeletonItems}</ul>
    </div>
  )
}
